<template>
  <div class="settings-page">
    <CRow>
      <CCol sm="12" md="6" lg="5" class="mb-4">
        <CCard>
          <CCardHeader>Limiti</CCardHeader>
          <CCardBody>
            <CForm>
              <CInput
                label="Calories limit"
                type="number"
                step="1"
                min="0"
                v-model.number="calories"
              />
              <div class="limits__error" v-if="fieldErrors.calories">{{ fieldErrors.calories }}</div>
              <CInput
                label="Sleep limit"
                type="number"
                step="0.1"
                min="0"
                max="24"
                v-model.number="sleep"
              />
              <div class="limits__error" v-if="fieldErrors.sleep">{{ fieldErrors.sleep }}</div>
              <CAlert show color="success" v-if="saveStatus === 'success'">
                Limiti su spremljeni.
              </CAlert>
              <CAlert show color="danger" v-if="saveError">
                {{ saveError }}
              </CAlert>
              <CButton color="primary" class="px-4" :disabled="isSaveDisabled" @click="onSaveClick">
                {{ isSaving ? "Spremam..." : "Spremi" }}
              </CButton>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol lg="6" class="mb-4">
        <CCard class="auth-card">
          <CCardBody>
            <div class="auth-card__eyebrow">Withings</div>
            <h2 class="auth-card__title">Update token</h2>
            <p class="auth-card__text">Osvjezi pristup za mjerenja tezine i povezane podatke.</p>
            <a :href="withingsTokenUrl" class="auth-card__link">Update Withings token</a>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol lg="6" class="mb-4">
        <CCard class="auth-card">
          <CCardBody>
            <div class="auth-card__eyebrow">Google Health</div>
            <h2 class="auth-card__title">{{ googleHealthTitle }}</h2>
            <p class="auth-card__text">Povezi san i prehranu preko Google Health API-ja.</p>
            <CAlert show color="warning" v-if="!$store.state.googleHealthConfigured">
              Google Health OAuth podaci nisu konfigurirani na serveru.
            </CAlert>
            <CAlert show color="danger" v-if="googleHealthError">
              {{ googleHealthError }}
            </CAlert>
            <CButton
              color="primary"
              class="px-4"
              :disabled="isGoogleHealthLoading || !$store.state.googleHealthConfigured"
              @click="onGoogleHealthConnect"
            >
              {{ isGoogleHealthLoading ? "Otvaram..." : googleHealthButtonText }}
            </CButton>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { services } from "../services/services";

export default {
  name: "Limits",
  data() {
    return {
      calories: this.$store.state.maxCalories,
      sleep: this.$store.state.minSleep,
      isSaving: false,
      saveStatus: null,
      saveError: null,
      googleHealthError: null,
      isGoogleHealthLoading: false,
    };
  },
  computed: {
    withingsTokenUrl() {
      return `https://account.withings.com/oauth2_user/authorize2?response_type=code&client_id=${this.$store.state.withingsClientId}&scope=user.info,user.metrics,user.activity&state=asdsad&redirect_uri=${document.location.origin}/WithingsAuth`;
    },
    googleHealthTitle() {
      return this.$store.state.googleHealthConnected ? "Povezano" : "Poveži račun";
    },
    googleHealthButtonText() {
      return this.$store.state.googleHealthConnected ? "Ponovno autoriziraj" : "Poveži Google Health";
    },
    fieldErrors() {
      const errors = {};

      if (!Number.isInteger(this.calories) || this.calories < 0) {
        errors.calories = "Calories limit mora biti cijeli broj veci ili jednak 0.";
      }

      if (!Number.isFinite(this.sleep) || this.sleep < 0 || this.sleep > 24) {
        errors.sleep = "Sleep limit mora biti broj izmedu 0 i 24.";
      }

      return errors;
    },
    isFormValid() {
      return Object.keys(this.fieldErrors).length === 0;
    },
    isSaveDisabled() {
      return this.isSaving || !this.isFormValid;
    },
  },
  methods: {
    onGoogleHealthConnect() {
      this.googleHealthError = null;
      this.isGoogleHealthLoading = true;
      services.getGoogleHealthAuthorizationUrl()
        .then((response) => {
          window.location.assign(response.body.url);
        })
        .catch((error) => {
          this.googleHealthError = error?.body?.error || "Google Health autorizacija nije dostupna.";
          this.isGoogleHealthLoading = false;
        });
    },
    onSaveClick() {
      if (!this.isFormValid) {
        this.saveStatus = null;
        this.saveError = "Ispravi polja prije spremanja.";
        return;
      }

      this.isSaving = true;
      this.saveStatus = null;
      this.saveError = null;

      services
        .updateLimits({
          calories: this.calories,
          sleep: this.sleep,
        })
        .then((response) => {
          this.$store.commit("limits", response.body);
          this.saveStatus = "success";
          this.saveError = null;
        })
        .catch((error) => {
          this.saveStatus = null;
          this.saveError = error?.body?.error || "Spremanje nije uspjelo.";
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.settings-page {
  display: grid;
  gap: 1.5rem;
}

.limits__error {
  margin-top: -0.5rem;
  margin-bottom: 1rem;
  color: #e55353;
  font-size: 0.875rem;
  font-weight: 500;
}

.auth-card {
  height: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: none;
}

.auth-card .card-body {
  display: grid;
  gap: 1rem;
  min-height: 220px;
  padding: 1.5rem;
  align-content: start;
}

.auth-card__eyebrow {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.auth-card__title {
  margin: 0;
  color: #0f172a;
  font-size: 1.3rem;
  font-weight: 700;
}

.auth-card__text {
  margin: 0;
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.6;
}

.auth-card__link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.5rem;
  width: fit-content;
  padding: 0.625rem 1rem;
  border-radius: 0.375rem;
  background: #0f766e;
  color: #ffffff;
  font-family: var(--font-display);
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  transition: background-color 150ms ease-in-out, transform 150ms ease-in-out, box-shadow 150ms ease-in-out;
}

.auth-card__link:hover {
  background: #047857;
  color: #ffffff;
  text-decoration: none;
  transform: translateY(-1px);
}

.auth-card__link:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(5, 150, 105, 0.25);
}
</style>
